import s from './style.module.scss';
const DotLoading = () => {
    return (
        <>
            <section className={s['dots-container']}>
                <div className={s['dot']}></div>
                <div className={s['dot']}></div>
                <div className={s['dot']}></div>
            </section>
        </>
    );
};

export default DotLoading;
